import { Avatar, Box, Paper, styled, Typography } from "@mui/material";
import { ClimateRisk, ClimateRiskLevel } from "types/types";

interface Props {
  climateRisk: ClimateRisk;
  climateRiskLevels: ClimateRiskLevel[];
}
export function ClimateRiskGraph(props: Props) {
  const { climateRisk, climateRiskLevels } = props;
  return (
    <StyledPaper elevation={0}>
      <Typography component="div" variant="h3-black" className="theme-title">
        <Avatar src={climateRisk.theme.iconUrl} variant="square" />
        {climateRisk.theme.name}
      </Typography>
      <Box className="scale-container">
        {climateRiskLevels.map((level) => (
          <Box
            className="scale-item"
            key={level.serialNumber}
            sx={{ backgroundColor: level.color }}
          >
            {level.serialNumber === climateRisk.level.serialNumber && (
              <div className={`label`}>
                <Typography>{climateRisk.scenario.year}</Typography>
              </div>
            )}
          </Box>
        ))}
      </Box>
    </StyledPaper>
  );
}

const StyledPaper = styled(Paper)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(3)};

  .theme-title {
    display: inline-flex;
    gap: ${({ theme }) => theme.spacing(1)};
    align-items: center;
    .MuiAvatar-img {
      width: 20px;
      height: 20px;
    }
  }

  .scale-item {
    height: 10px;
    flex-grow: 1;
    position: relative;
  }

  .scale-container {
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    width: 100%;
    .label {
      position: absolute;
      font-weight: 700;
      top: -300%;
      left: 50%;
      transform: translate(-50%);
      z-index: 2;
      ::after {
        content: "";
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        border-top: solid 15px ${({ theme }) => theme.palette.common.black};
        border-left: solid 10px transparent;
        border-right: solid 10px transparent;
      }
    }
  }
`;
